"use client";

import { useDealerStatus } from "@/hooks/use-dealer-status";
import { formatCurrency } from "@/lib/utils";
import { Tag } from "lucide-react";

interface ProductPriceDisplayProps {
  price: number;
  compareAtPrice?: number;
  dealerPrice?: number | null;
}

export function ProductPriceDisplay({ price, compareAtPrice, dealerPrice: fixedDealerPrice }: ProductPriceDisplayProps) {
  const { isApproved, discountPercentage, dealerGroupName } = useDealerStatus();

  const resolvedDealerPrice = isApproved
    ? (fixedDealerPrice ?? (discountPercentage > 0 ? price * (1 - discountPercentage / 100) : null))
    : null;

  return (
    <div className="flex flex-col gap-2 pb-6 border-b border-gray-100 mt-2">
      <div className="flex items-baseline gap-3">
        <span className="text-2xl font-bold text-gray-950">
          {formatCurrency(price)}
        </span>
        {compareAtPrice && compareAtPrice > price && (
          <span className="text-lg text-gray-400 line-through">
            {formatCurrency(compareAtPrice)}
          </span>
        )}
      </div>
      {resolvedDealerPrice && (
        <span className="inline-flex items-center gap-1.5 text-xs font-medium text-emerald-700 bg-emerald-50 border border-emerald-100 px-2.5 py-1 rounded-sm w-fit">
          <Tag className="h-3 w-3" />
          {dealerGroupName} {formatCurrency(resolvedDealerPrice)}
        </span>
      )}
    </div>
  );
}
